export default {
  'user.profile.company': 'Company',
  'user.profile.position': 'Position',
  'user.profile.changePassword': 'Change Password',
  'user.profile.twoFactor': 'Enable Two-Factor',
  'user.profile.modifyView': 'Modify View',
  'user.profile.currentPassword': 'Current Password',
  'user.profile.password': 'New Password',
  'user.profile.confirmPassword': 'Confirm Password',
  'user.profile.labelTwoFactor': 'Is Two-Factor Authentication Enabled?',
  'user.profile.': ' ',

  'user.menu.logout': 'Logout',
  'user.menu.options': 'Options',
  'user.menu.profile': 'Profile',
  'user.menu.resetPassword': 'Reset Password',
  'user.menu.locales': 'Languages',
  'user.menu.environments': 'Environments',
  'user.menu.companies': 'Companies',

  'user.forgot.title': 'Forgot Password',
  'user.forgot.sent': 'Done!',
  'user.forgot.description':
    'Enter your email and we will send you a message to create your new password',
  'user.forgot.sent.description':
    'We have sent you a link to your email so you can create a new password.',

  'user.login.email.placeholder': 'you@company.com',
  'user.login.password.placeholder': 'Enter your password',
  'user.login.newPassword.placeholder': 'Create your new password',
  'user.login.confirmPassword.placeholder': 'Repeat your password',
  'user.login.code.placeholder': 'Enter the code',

  'user.login.error.email.required': 'Please enter your email address',
  'user.login.error.email.invalid': 'Please enter a valid email address',
  'user.login.error.password.required': 'Please enter your password',
  'user.login.error.confirmPassword.required': 'Please confirm your password',
  'user.login.error.code.required': 'Please enter the verification code',

  'user.login.forgotPassword': 'Forgot Password',
  'user.login.reset.hint':
    'Must be at least 8 characters long, include uppercase and lowercase letters, a number, and a special character "!#*$@%&?".',
  'user.login.reset.sent': 'Your new password has been successfully created.',
  'user.login.reset.title': 'Enter your new password',
  'user.login.reset.link.error.title': 'Error',
  'user.login.reset.link.error.description': 'The link for password reset is invalid.',

  'user.twoFactor.providers': 'Providers',
  'user.twoFactor.provider.email': 'Email Code',
  'user.twoFactor.title': 'Send Verification Code',
  'user.twoFactor.description': 'Select Two-Factor Authentication provider',
  'user.twoFactor.code.title': 'Enter Verification Code',
  'user.twoFactor.alert.title': 'Done!',
  'user.twoFactor.alert.description': 'We have sent you an email with the security code.',
  'user.twoFactor.error.send': 'Error sending verification code. Please try again.',
  'user.twoFactor.error.validate': 'Incorrect security code. Please try again.',

  'user.login.subtitle': 'Or continue with',
  'user.login.sso.success.title': 'Login successful',
  'user.login.sso.success.description': 'You have signed in successfully.',
  'user.login.sso.success.badge': 'Session authorized',
  'user.login.sso.success.redirect': 'Redirecting you in {seconds}s…',

  'user.rpaAuth.product': 'AUTOMY RPA DESIGNER',
  'user.rpaAuth.title': 'Authentication successful',
  'user.rpaAuth.description':
    'You can return to the application. This tab will try to close automatically.',
  'user.rpaAuth.badge': 'Session authorized',
  'user.rpaAuth.manualCloseHint': 'If the tab does not close, you can close it manually.',
  'user.rpaAuth.action.closeTab': 'Close tab',
  'user.rpaAuth.browserBlockHint': 'Some browsers block automatic closing for security reasons.',
  'user.login.confirm.link.error.description': 'The link to confirm your account is invalid.',
  'user.login.banner.eyebrow': 'No-Code Hyperautomation',
  'user.login.banner.title': 'Automation that',
  'user.login.banner.titleAccent': 'works for you',
  'user.login.banner.description':
    'Build workflows, deploy AI agents, and run RPA bots. All without writing a single line of code.',
  'user.login.banner.trust': 'Trusted by leading enterprises across 10+ countries.',
  'user.login.banner.feature.workflows': 'Workflows',
  'user.login.banner.feature.agents': 'AI Agents',
  'user.login.banner.feature.apps': 'Apps',
  'user.login.banner.feature.rpa': 'RPA',

  'user.login.legal.privacy': 'Privacy Policy',
  'user.login.legal.terms': 'Terms & Conditions',
  'user.login.legal.copyright': '© {year} AUTOMY GLOBAL CORP. All rights reserved.',

  'user.accessBlocked.title': 'Access temporarily blocked',
  'user.accessBlocked.description':
    'Your company cannot access AUTOMY right now. Contact support or an administrator to resolve this.',
  'user.accessBlocked.code.companyInactive': 'The company is inactive and cannot access AUTOMY.',
  'user.accessBlocked.code.subscriptionNotFound':
    'No active subscription was found for the company.',
  'user.accessBlocked.code.pendingActivation': 'The company subscription is pending activation.',
  'user.accessBlocked.code.pendingPayment': 'The company subscription has a pending payment.',
  'user.accessBlocked.code.paymentMethodRequired':
    'A payment method is required to continue. Sign in again to complete the process.',
  'user.accessBlocked.code.pastDue': 'The company subscription payment is past due.',
  'user.accessBlocked.code.canceled': 'The company subscription was canceled.',
  'user.accessBlocked.code.suspended': 'The company subscription is suspended.',
  'user.accessBlocked.action.contactSupport': 'Contact support',
  'user.accessBlocked.action.contactAdmin': 'Got it',
  'user.accessBlocked.action.relogin': 'Sign in again',
  'user.accessBlocked.action.backToLogin': 'Back to sign in',
  'user.accessBlocked.billingReloginHint':
    'To complete payment or set up a payment method, sign in again. You will be guided through a restricted access flow.',
  'user.accessBlocked.contactAdminHint':
    'A company administrator must resolve the billing or subscription status.',

  'user.billingRecovery.title': 'Complete billing setup',
  'user.billingRecovery.title.setup': 'Set up your payment method',
  'user.billingRecovery.title.pay': 'Complete your subscription payment',
  'user.billingRecovery.action.setupPaymentMethod': 'Set up payment method',
  'user.billingRecovery.action.paySubscription': 'Pay subscription',
  'user.billingRecovery.secureBadge': 'Secure connection',
  'user.billingRecovery.trustHint':
    'You will be redirected to {stripe} to complete the process securely. AUTOMY does not store your card details.',
  'user.billingRecovery.loading': 'Preparing your secure access…',
  'user.billingRecovery.tokenExpired.title': 'Recovery session expired',
  'user.billingRecovery.tokenExpired.description':
    'Restricted access expired. Sign in again to continue with billing.',
  'user.billingRecovery.error.stateChanged':
    'The subscription status changed. Sign in again to refresh the information.',
  'user.billingRecovery.error.paymentMethodRequired': 'You must set up a payment method first.',
  'user.billingRecovery.error.manualPayment':
    'This subscription requires manual payment. Contact support.',
  'user.billingRecovery.error.actionNotAllowed':
    'Your current access does not allow this action. Sign in again.',
  'user.billingRecovery.error.amountInvalid':
    'A valid amount could not be resolved to pay the subscription.',
  'user.billingRecovery.error.generic':
    'Could not start the payment process. Try again or sign in again.',
  'user.billingRecovery.result.successTitle': 'Process completed',
  'user.billingRecovery.result.successDescription':
    'If payment or setup completed, sign in again to access AUTOMY.',
  'user.billingRecovery.result.cancelTitle': 'Process canceled',
  'user.billingRecovery.result.cancelDescription':
    'You canceled the payment process. You can sign in again and try once more.',
  'user.billingRecovery.result.doneTitle': 'Done',
  'user.billingRecovery.result.doneDescription': 'Sign in again to continue.',
  'user.billingRecovery.result.confirmingTitle': 'Confirming…',
  'user.billingRecovery.result.confirmingDescription':
    'We are verifying the payment result with the provider. This may take a few seconds.',
  'user.billingRecovery.result.cancelPendingDescription':
    'We are confirming whether the process was canceled or the payment is still processing.',
  'user.billingRecovery.result.pendingTimeoutTitle': 'Confirmation in progress',
  'user.billingRecovery.result.pendingTimeoutDescription':
    'We have not received a final confirmation yet. Sign in again in a few minutes or retry.',
  'user.billingRecovery.result.setupCompletedTitle': 'Payment method configured',
  'user.billingRecovery.result.setupCompletedDescription':
    'Your payment method was saved. Sign in again to continue; subscription payment may still be required.',
  'user.billingRecovery.result.setupCompletedNextDescription':
    'Your payment method was saved. We are updating billing status to continue with payment.',
  'user.billingRecovery.result.confirmingMethodTitle': 'Confirming payment method…',
  'user.billingRecovery.result.confirmingMethodDescription':
    'We are confirming your payment method. This may take a few seconds; do not close this window.',
  'user.billingRecovery.result.confirmingMethodTimeoutTitle': 'Confirmation in progress',
  'user.billingRecovery.result.confirmingMethodTimeoutDescription':
    'The payment method is not reflected yet. You can retry or sign in again.',
  'user.billingRecovery.result.accessAllowedTitle': 'Subscription active',
  'user.billingRecovery.result.accessAllowedDescription':
    'Your subscription is already active. Sign in again to continue.',
  'user.billingRecovery.result.paymentCompletedTitle': 'Subscription payment confirmed',
  'user.billingRecovery.result.paymentCompletedDescription':
    'Payment was confirmed. Sign in again to access AUTOMY.',
  'user.billingRecovery.result.failedTitle': 'Could not confirm',
  'user.billingRecovery.result.failedDescription':
    'The payment process did not complete. You can retry or sign in again.',
  'user.billingRecovery.result.expiredTitle': 'Session expired',
  'user.billingRecovery.result.expiredDescription':
    'The payment session expired. Sign in again and try once more.',
  'user.billingRecovery.result.missingSessionTitle': 'Payment session not found',
  'user.billingRecovery.result.missingSessionDescription':
    'We could not find the payment session id. Sign in again and try once more.',
  'user.billingRecovery.action.retry': 'Retry',

  'user.support.title': 'Contact support',
  'user.support.hint':
    'If your company cannot access due to billing or activation, support can help.',
};
